import { environment } from '../../../environments/environment';

export const AuthConfig = {
  // Terega Auth0
  domain: environment.auth0Domain,
  clientId: environment.auth0ClientId,
  audience: environment.cortexOAuth2Audience,
  scopes: environment.cortexOAuth2Scopes,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: 'openid profile email',
  },
};

export const IobaseAuthConfig = {
  // IOBase/Indaba Auth0
  domain: environment.iobaseAuth0Domain,
  clientId: environment.iobaseAuthorizerTeregaClientId,
  audience: environment.iobaseIndabaOAuth2Audience,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: 'openid profile email',
  },
};
